import { createContext, useContext } from 'react';

import { ModalRequest } from '@/modals';

interface ImperativeModals {
  show(request: ModalRequest): void;
}

export const ModalsContext = createContext<ImperativeModals>(null!);

export function useModals() {
  return useContext(ModalsContext);
}
